
// Test data for Level 3 Bunker Training

export const bunkerTests = [
  {
    id: "bunker-court",
    title: "Bunkers court",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 3 cercles de 0.5, 1, 2 m. Placer sa balle dans un bunker de green, taper 10 balles depuis les distances A=3, B=7, C=10 m et compter les points selon le cercle d'arrivée.",
    icon: "🏖️"
  },
  {
    id: "bunker-long",
    title: "Bunker long",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 3 cercles de 0.5, 1, 2 m (1/2 fer 5 H, 1 fer 5 H, etc…). Placer sa balle dans un bunker de green, taper 10 balles depuis aux distances D=25 m et compter les points selon le cercle d'arrivée.",
    icon: "🏝️"
  }
];
